var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50232 2.45127L11.5499 5.49889M2.12365 8.82994L5.17127 11.8776M5.17127 11.8765L0.904602 13.0956L2.12365 8.82892L9.4166 1.53597C9.61671 1.33586 9.85428 1.17712 10.1157 1.06882C10.3772 0.960526 10.6574 0.904785 10.9404 0.904785C11.2234 0.904785 11.5036 0.960526 11.7651 1.06882C12.0265 1.17712 12.2641 1.33586 12.4642 1.53597C12.6643 1.73608 12.8231 1.97364 12.9314 2.2351C13.0397 2.49655 13.0954 2.77678 13.0954 3.05978C13.0954 3.34278 13.0397 3.623 12.9314 3.88446C12.8231 4.14591 12.6643 4.38348 12.4642 4.58359L5.17127 11.8765Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.c3c1cd84684f0bf80b346bbc34e23cc1.svg";
export { ForwardRef as ReactComponent };